export const fmtText = txt => {
  if (txt === 'null') {
    return null;
  }
  return decodeHTML(removeHTML(txt));
};

export const decreaseTxt = (txt, maxCharacters) => `${txt.slice(0, maxCharacters)}...`;

export const decodeHTML = str => {
  try {
    return str
      .replace(/&amp;/g, '&')
      .replace(/&lt;/g, '<')
      .replace(/&gt;/g, '>')
      .replace(/&quot;/g, '"')
      .replace(/&#039;/g, "'"); // eslint-disable-line
  } catch (e) {
    return '';
  }
};

export const removeHTML = str => {
  try {
    return str.replace(/<[^>]*>/g, '');
  } catch (e) {
    return '';
  }
};
